<template>
  <AttrGroup v-if="show" title="播放">
    <AttrSwitch
      label="重复播放"
      :disabled="!!attrDisabled"
      :value="shape.attrs.infinite"
      :tooltip="'当关闭重复播放时，默认播放一次'"
      @change="toggleRepeat"
    />
    <AttrInputNumber
      v-if="spriteItems.length === 1"
      class="mt-2.5"
      label="播放次数"
      :min="1"
      :max="10"
      :precision="0"
      :disabled="!!attrDisabled || shape.attrs.infinite"
      :value="shape.attrs.repeatCount"
      :tooltip="'播放次数大于等于1，但不能超过10'"
      @change="(num: number) => shape.setAttrs({ repeatCount: num })"
    />
    <AttrInputNumber
      v-if="isSprite"
      class="mt-2.5"
      label="帧率"
      :min="1"
      :max="60"
      :precision="0"
      :disabled="!!attrDisabled"
      :value="shape.attrs.spriteFps ?? 60"
      @change="(num: number) => shape.setAttrs({ spriteFps: num })"
    />
  </AttrGroup>
</template>

<script lang="ts" setup>
import { useWatchfaceAndroid } from '@/hooks';
import { Shape } from '@/services/shape';
import { SpriteAttribute } from '@/services/shape/attributes/sprite';
import { useEditorStore } from '@/store/use-editor-store';
import { computed, watch } from 'vue';
import { PropType, ref } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  isSprite: {
    type: Boolean,
    required: true
  },
  isVideo: {
    type: Boolean,
    required: true
  },
  spriteItems: {
    type: Array as PropType<SpriteAttribute['spriteExtra']>,
    default: () => []
  }
});

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);
const { androidWatcfaceOS } = useWatchfaceAndroid();

const repeat = ref(false);
// 监听spriteItems长度变化,当多个视频时，此时不展示播放次数编辑框，播放次数需重置为1,
watch(
  () => props.spriteItems.length,
  (val) => {
    if (val > 1) {
      props.shape.setAttrs({ repeatCount: 1 });
    }
  }
);
const toggleRepeat = (checked: boolean) => {
  repeat.value = checked;
  props.shape.setAttrs({
    infinite: !!checked
  });
  // 当关闭重复播放时，默认播放一次
  if (!checked) {
    props.shape.setAttrs({ repeatCount: 1 });
  }
};

// 是否展示配置项
const show = computed(() => {
  const { isSprite, isVideo } = props;
  // 两种情况需要展示配置项
  return (
    // 1 序列帧
    isSprite ||
    // 2 视频，但是设备必须满足
    // 2.1 非安卓设备
    // 2.2 是安卓设备但是必须是智能
    (isVideo &&
      // android 设备为Android且表盘为android
      // not-android-device 设备为非安卓设备
      ['android', 'not-android-device'].includes(androidWatcfaceOS.value))
  );
});
</script>
